
export class SupportAuthUserInfo {
  SupportAuthUserId: number
  SupportAuthUserType: string
  EmpCode: string
  EmpName: string
  ProjectCode: string
  ProjectName: string
  CompanyCode: string
  SupportAuthUserRole: string // Role ID
  SupportAuthUserPhone: string
  SupportAuthUserEmail: string
  SupportAuthUserPosition: string // Role name

  SupportAuthUserRoleName: string
  SupportAuthUserRoleTier: number

  EmpNickName: string

  CreateDate: string
  CreateBy: string
  UpdateDate: string
  UpdateBy: string
  WhereProjectStatus: string
  lookupMappingTier: string
  FlagDelete: string
}



export class SupportAuthUser {
  SupportAuthUserId: number
  SupportAuthUserType: string
  EmpCode: string
  ProjectCode: string
  CompanyCode: string
  SupportAuthUserRole: string
  SupportAuthUserPhone: string
  SupportAuthUserEmail: string
  SupportAuthUserPosition: string
  CreateDate: string
  CreateBy: string
  UpdateDate: string
  UpdateBy: string
//   WhereProjectStatus: string
//   lookupMappingTier: string
  FlagDelete: string
}
